import React from 'react';

import { BaseIconProps } from './';

export const Chevron = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.1011673,0,0,-2.1011673,-8.4046653,1075.7977)"
    d="M 102,58 163,-2 420,255 163,512 102,452 298,255 Z"
    stroke={fill}
    fill={fill}
  />
);
